// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-83fd8a68] {\n  padding: 2rem 4rem 1.5rem;\n  text-transform: uppercase;\n  font-family: var(--font-poppins);\n  font-weight: 600;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
